import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, from, Observable, switchMap, throwError } from 'rxjs';

export const forbiddenInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status !== 403) return throwError(() => err);

            if (err.error instanceof Blob) {
                return from(err.error.text()).pipe(
                    switchMap(text => {
                        const error = JSON.parse(text);
                        router.navigate(['/access-restricted'], { queryParams: { error: error.key } });
                        return EMPTY;
                    })
                );
            }

            router.navigate(['/access-restricted'], { queryParams: { error: err.error?.key } });
            return EMPTY;
        })
    );
};
